<template>
  <!-- TODO: ADD LAZY LOADING TO LOOK WHAT I FOUND -->
  <div v-if="data.media_type.value === 'video'" ref="el" class="group relative size-full">
    <video
      v-if="data.video"
      ref="video"
      loop
      :autoplay="autoplay"
      muted
      playsinline
      class="size-full object-cover"
    >
      <source v-if="load" :src="data.video.permalink" :type="`video/${data.video.extension}`" />
      Your browser does not support the video tag.
    </video>
    <AppImage
      v-if="data.cover_image && data.cover_image.is_image"
      :loading="isHero ? 'eager' : 'lazy'"
      class="
        absolute left-0 top-0 z-10 size-full object-cover opacity-100 transition-opacity duration-300 ease-in
        group-hover:opacity-0 group-hover:delay-75 group-hover:duration-500 group-hover:ease-in-out
      "
      :src="data.cover_image"
    />
  </div>
  <AppImage
    v-else
    :loading="isHero ? 'eager' : 'lazy'"
    class="size-full object-cover"
    :src="data.image"
  />
</template>

<script setup lang="ts">
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import type { MainComponentsComponentHeroModuleFragment } from '#gql'

gsap.registerPlugin(ScrollTrigger)

const props = withDefaults(defineProps<{
  data: Pick<Enforce<MainComponentsComponentHeroModuleFragment>, 'media_type' | 'image' | 'video' | 'cover_image'>
  autoplay?: boolean
}>(), {
  autoplay: false,
})

const isHero = inject<boolean>('isHero', false)

const el = ref<HTMLElement>()
const video = ref<HTMLVideoElement | null>(null)
const ctx = useGsap.context(() => {})

const load = ref(false)

function playVideo() {
  if (video.value) {
    video.value.play()
  }
}

function pauseVideo() {
  if (video.value) {
    video.value.pause()
  }
}

const initScrolltrigger = () => {
  ctx.add(() => {
    ScrollTrigger.create({
      trigger: el.value,
      start: 'top-=150% center',
      end: 'bottom-=-150% center',
      markers: false,
      onToggle: (self) => {
        if (self.isActive) {
          load.value = true
        }
      },
    })
  })
}

defineExpose({
  playVideo,
  pauseVideo,
})

onMounted(() => {
  if (props.data.media_type.value === 'video') {
    initScrolltrigger()
  }
})

onUnmounted(() => {
  ctx?.revert()
})
</script>
